import { ReactElement } from 'react';
import ReviewEmployeeAccess from './ReviewEmployeeAccess/ReviewEmployeeAccess';
import withQueryCheck from 'pages/AnnualUserAccessReview/components/withQueryCheck';

/**
 * Form to submit when manager wishes to review and validate employee access
 * @returns {ReactElement} User Access Review Employee Review Form
 */
const ReviewForm = props => {
	return <ReviewEmployeeAccess {...props} />;
};

export default withQueryCheck(ReviewForm);
